module.exports = __webpack_public_path__ + "assets/img/bg-software.aa9236f8.jpg";